import { useMutation } from "@tanstack/react-query";
import { pwdCheckResetUrlApi } from "components/api/user";
import { useAuthContext } from "components/context/authContext";
import ResetPwdView from "components/view/mypage/resetpwd";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { alertControl, successControl } from "util/commAction";

export default function ResetPwdPage() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { lodInf } = useAuthContext();

  const mailUrlCheck = useMutation({
    mutationKey: ["milUrlCheck"],
    mutationFn: pwdCheckResetUrlApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            //비밀번호
          },
        });
      }
    },
  });

  useEffect(() => {
    if (!search) {
      alertControl({
        isOpen: true,
        inner: "정확한 url이 아닙니다. / 홈페이지로 이동합니다.",

        click: () => {
          if (lodInf?.lodNo) {
            navigate("/" + lodInf?.lodNo);
          }
          if (!lodInf?.lodNo) {
            navigate("/");
          }
        },
      });
    }
    if (!!search) {
      // 비밀번호 재설정 url 확인
      mailUrlCheck.mutate({ param: search });
    }
  }, [search]);

  return (
    <>
      <ResetPwdView />
    </>
  );
}
